import { Mutation } from 'vuex';
import { IModuleState } from './types';

// 会员/企业列表
export const setFinanceLogs: Mutation<IModuleState> = (state, payload) => {
  state.logs.data = payload.data;
  state.logs.pageNum = payload.pageNum;
  state.logs.pageSize = payload.pageSize;
  state.logs.total = payload.total;
  state.logs.loading = !!payload.loading;
};

export const setLoading: Mutation<IModuleState> = (state, payload) => {
  state.loading = payload;
};
